import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Moment from 'moment';
import { Link } from 'react-router';

import { ProjectsModalFlow } from '../flow-projects/projects-modal';
import ModalManager from '../elements-modal/modal-manager';
import { Avatar } from 'shared-components/image/avatar';
import AvatarGroup from '../elements-image/avatar-group';
import { Tooltip } from '../elements-tooltip/tooltip-v2';
import { InviteShareBtn } from '../elements-buttons/invite-share-button';
import { ProjectDetailsSettingsModal } from '../flow-projects/project-details-settings-modal';

import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ProjectInfo extends Component {
  constructor (props) {
    super(props);

    this.renderDate = this.renderDate.bind(this);
    this.openInviteModal = this.openInviteModal.bind(this);
    this.headerCTA = this.headerCTA.bind(this);
    this.determineHeaderCTAView = this.determineHeaderCTAView.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    const { showInviteModal } = this.props;
    const { showInviteModal: nextShowInviteModal } = nextProps;

    if (!showInviteModal && nextShowInviteModal) {
      this.openInviteModal();
    }
  }

  openInviteModal () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <ProjectsModalFlow
          { ...this.props }
          modalType={'share'}
          openModal={ this.openInviteModal }
          analyticsOrigin={ 'board details page' }
          closeModal={this.props.closeInviteModal}
        />
      </SharedIntlProviderHOC>, document.getElementById('modal-container')
    );
  }

  renderDate (schedule) {
    if (schedule.length && schedule[0].start) {
      const s = schedule[0].start.date;
      const { d, m, y } = s;
      const momentSchedule = Moment().set({ month: m - 1, date: d, year: y });
      const converted = momentSchedule;
      const formatted = converted.format('MMMM DD, YYYY');

      return <span>· { formatted } ·</span>;
    }

    return '·';
  }

  renderSettingsIcon () {
    const { project: { type, created_by_sso_id, external_id }, accessToken, profile = {} } = this.props;

    if (('UNCATEGORIZED_FAVS' !== type && accessToken) && (profile.SSOid === created_by_sso_id)) {
      return (
        <span>
          <Link to={{ pathname: `/boards/${external_id}/settings` }} className="remove-click-styling">
            <i className="icon-gear" />
          </Link>
        </span>
      );
    }

    return null;
  }

  renderCollaboratorAvatars (avatars, collabCount) {
    return (
      <span className="list-inline">
        <li className="v-center">
          <FormattedMessage
            id="boards.project_info.collaborators"
            defaultMessage="{count} collaborators"
            values={{
              count: collabCount
            }}
          />
        </li>
        <li className="v-center">
          <AvatarGroup
            urls={avatars}
          />
        </li>
      </span>
    );
  }

  renderOwnerAvatar (owner) {
    const { userLoggedInInvited, userLoggedOutInvited } = this.props;
    return (
      <span className="list-inline">
        {
          userLoggedInInvited || userLoggedOutInvited ?
        <li className="v-center">
          <FormattedMessage
            id="boards.project_info.owner"
            defaultMessage="Owner"
          />
        </li>
        :
        <li className="v-center">
          <FormattedMessage
            id="boards.project_info.created_by"
            defaultMessage="Created By"
          />
        </li>
        }
        <li className="v-center">
          <Avatar
            src={'/web-2/assets/images/no_avatar_placeholder.svg?v=rb'}
            id={owner.avatar_id}
            maxWidth="30px"
          />
        </li>
        <li className="v-center margin-lg-right">
          {owner.first_name} {owner.last_name}
        </li>
      </span>
    );
  }

  headerOwnerView () {
    const { project = {} } = this.props;

    return (
      <div>
        <Link to={{ pathname: `/boards/${project.external_id}/invite` }} className="remove-click-styling">
          <button className="btn btn-md btn-primary btn-md" tabIndex="0">
            <i className="v-center ico-lg icon-mail-outline margin-md-right" />
            <span className="v-center">
              <FormattedMessage
                id="boards.project_info.invite"
                defaultMessage="Invite"
              />
            </span>
          </button>
        </Link>
        <button className="btn btn-primary-outline btn-md copy-focus-btn btn-outlined-light" onClick={ this.props.handleCopyBoardButton } >
          <i className="v-center ico-lg icon-duplicate margin-md-right" />
          <span className="v-center">
            <FormattedMessage
              id="boards.project_info.duplicate_owner"
              defaultMessage="Duplicate Board"
            />
          </span>
        </button>
      </div>
    );
  }

  headerUnauthorizedView () {
    return (
      <div>
        <button className="btn btn-primary-outline btn-md copy-focus-btn btn-outlined-light" onClick={ this.props.handleCopyBoardButton } >
          <i className="v-center ico-lg icon-duplicate margin-md-right" />
          <span className="v-center">
            <FormattedMessage
              id="boards.project_info.duplicate_owner"
              defaultMessage="Duplicate Board"
            />
          </span>
        </button>
      </div>
    );
  }

  headerCollabView () {
    const { project } = this.props;
    return (
      <div>
        <button className="btn btn-primary btn-md" onClick={ this.props.handleCopyBoardButton } >
          <i className="v-center ico-lg icon-duplicate margin-md-right" />
          <span className="v-center">
            <FormattedMessage
              id="boards.project_info.duplicate_board"
              defaultMessage="Duplicate Board"
            />
          </span>
        </button>
        <InviteShareBtn
          optionalBtnStyle={ { display: 'inline-block' } }
          link={`/boards/${project.external_id}`}
          btnColor="btn-primary-outline col-xs-12 copy-focus-btn"
          title={
            <div>
              <i className="v-center ico-lg icon-link margin-md-right" />
              <span className="v-center">
                <FormattedMessage
                  id="boards.project_info.copy_link"
                  defaultMessage="Copy Link"
                />
              </span>
            </div>
          }
          actions={
            {
              click: () => { return; }
            }
          }
          removeInput
          btnSize="btn-md cta-min-width"
        />
      </div>
    );
  }

  headerSignedOutView ({ handleTopSignupButton, handleCopyBoardButton }) {
    const toolTipText = this.props.intl.formatMessage({ id: 'boards.project_info.like_spaces', defaultMessage: 'Like these spaces? Save a copy of this board.' }) ;
    const copyButtonWithTooltip = (
      <div className="copy-board-tooltip-wrapper">
        <Tooltip
          placement="bottom"
          id="copy-board-tooltip"
          tooltipClass="copy-board-tooltip blue-tooltip"
          arrowPlacement={{
            arrowLeft: 192,
            left: -120,
            top: 10
          }}
          anchorClickCB={(tooltipHelpers) => {
            if (tooltipHelpers.open) {
              tooltipHelpers.showTooltip(false);
            }
            handleCopyBoardButton();
          }}
          anchorType="custom"
          customAnchor={
            <button className="btn btn-primary btn-md">
              <i className="v-center ico-lg icon-duplicate margin-md-right" />
              <span className="v-center">
                <FormattedMessage
                  id="boards.project_info.duplicate_signed_header"
                  defaultMessage="Duplicate Board"
                />
              </span>
            </button>
          }
          showX
          openOnRender
          hideOnClickAnywhere={ false }
          delayRenderBy={4}
        >
          <div>
            <span>{ toolTipText }</span>
          </div>
        </Tooltip>
      </div>
    );
    return (
      <div>
        { !!_.get(this.props, 'project.tastemaker') ?
          copyButtonWithTooltip
          :
          <button onClick={ handleCopyBoardButton } className="btn btn-primary btn-md">
            <i className="v-center ico-lg icon-duplicate margin-md-right" />
            <span className="v-center">
              <FormattedMessage
                id="boards.project_info.duplicate_signed"
                defaultMessage="Duplicate Board"
              />
            </span>
          </button>
        }
        <button
          className="btn btn-md btn-primary-outline copy-focus-btn"
          onClick={ () => {
            handleTopSignupButton();
          }}
        >
          <span className="v-center">
            <FormattedMessage
              id="boards.project_info.sign_up"
              defaultMessage="Sign Up"
            />
          </span>
        </button>
      </div>
    );
  }

  determineHeaderCTAView () {
    const { project = {}, accessToken, profile = {}, handleCopyBoardButton, handleTopSignupButton, userLoggedInInvited, userLoggedOutInvited } = this.props;
    const userIsSignedIn = accessToken && profile.SSOid;
    const hasProjectInfo = Object.keys(project).length;
    const showOwnerView = (userIsSignedIn || userLoggedOutInvited) && hasProjectInfo && (userLoggedInInvited || userLoggedOutInvited);
    
    if (showOwnerView) {
      return this.headerOwnerView(userLoggedOutInvited);
    } else if (!userLoggedInInvited) {
      return this.headerUnauthorizedView();
    } else {
      return this.headerSignedOutView({ handleTopSignupButton, handleCopyBoardButton });
    }
  }

  headerCTA () {
    const { project = {}, userLoggedInInvited, userLoggedOutInvited } = this.props;
    const { created_by_profile: createdProfile = {} } = project;
    const { collaborators = [] } = project;
    const collabAvatars = _.compact(_.map(collaborators, (collab) => _.get(collab, 'avatar_url', '/web-2/assets/images/no_avatar_placeholder.svg?v=rb')));
    const showCollaboratorAvatars = collabAvatars.length > 1 && (userLoggedInInvited || userLoggedOutInvited);

    return (
      <div>
        <ul className="list-inline">
          { showCollaboratorAvatars ?
              this.renderCollaboratorAvatars(collabAvatars, collaborators.length)
            : this.renderOwnerAvatar(createdProfile)
          }
          <li className="cta-container v-center">
            { this.determineHeaderCTAView() }
          </li>
        </ul>
      </div>
    );
  }

  renderProjectInfo () {
    const { project } = this.props;
    const { location, schedule, activity, type } = project;
    const shouldShowInfo = type !== 'UNCATEGORIZED_FAVS' && (location || schedule.length || activity);

    if (shouldShowInfo) {
      return <p className="project-subtitle ellipsis no-bottom-margin">{ activity } { this.renderDate(schedule) } { location }</p>;
    }
    return null;
  }

  render () {
    const { project } = this.props;
    const { name } = project;
    return (
      <div className='project-info-container ps-container flex middle'>
        <div className='ps-row flex-one'>
          <div
            className='col-xs-12 project-info-inner'
            style={{ gap: '8px' }}
          >
            <div className='flex-one'>
              <h3 className='project-title'>
                {name} {this.renderSettingsIcon()}
              </h3>
              {this.renderProjectInfo()}
            </div>
            <div className='header-cta text-xs-left text-sm-right'>
              {this.headerCTA()}
            </div>
          </div>
        </div>

        <ModalManager {...this.props}>
          <ProjectDetailsSettingsModal ref='projectSettingsModal' />
        </ModalManager>
      </div>
    );
  }
}

export default injectIntl(ProjectInfo);
